export default __webpack_public_path__ + "static/media/boleto.d43460d7.svg";